<!--
================================================
Un composant qui affiche la durée total de temps enregistré pour une période. Fait partie de la report View.

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports/summary

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="PeriodDurationComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

        <span class="txt">
            {{$t('TempsTotal')}} :
        </span>
        <span class="duration">
            {{duration}}
        </span>
    </div>

<!--    https://www.npmjs.com/package/v-click-outside-->
<!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    // import SentryMixin from "../../mixins/SentryMixin.js";
    import TimeMixin from "../../mixins/TimeMixin.js";
    // import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
    // import InterceptorMixin from "../../mixins/InterceptorMixin.js";
    // import _ from 'lodash'
    import {mapState} from 'vuex'


    import _ from "lodash";

    export default {
        name: 'PeriodDurationComp', //utile dans vue dev tool
        mixins: [
            TimeMixin,
            // GlobalErrorNotification,
            // SentryMixin,
            // InterceptorMixin
        ],
        // components: {},

        props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            timerecordsOfPeriod: Object
        },
        data: function () {
            return {
                locale : this.$route.params.locale
                ,duration: "0 h"  // String | la durée totale de la période
            }
        },

        computed:{
          ...mapState({
            themeToDisplay: state => state.app.themeToDisplay,
          })

        },
        watch: {
            // à chaque fois que la prop computed change, cette fonction s'exécutera
            timerecordsOfPeriod: function () {
                this.calculatePeriodDuration()
            }
        },

        methods: {

            /*
              Calcule la durée de la période
             */
            calculatePeriodDuration(){

                let periodDuration = null
                let groupDuration = null
                let self = this
                _.forOwn(this.timerecordsOfPeriod, function (groupOfTimerecord) { // groupOfTimerecord contient les tr groupés par jours

                    // on boucle sur tous les tr du groupe jour et on calcule la durée total
                    _.forOwn(groupOfTimerecord, function (timerecord) {
                        groupDuration = groupDuration + parseInt( self.calculateDuration(self.$moment, timerecord.timeIn, timerecord.timeOut)._milliseconds)

                    })
                })

                // on ajoute la durée du groupe au total de la période
                periodDuration =+ groupDuration

                // on créé un nouvel objet moment duration avec notre total en milliseconde
                let momentDuration = self.$moment.duration(periodDuration)
                this.duration = this.formatDurationInHourAndMin(momentDuration, this.$moment, this.locale)

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar.scss";
    @import "../../assets/css/bulmaResponsiveDep.scss";

    #PeriodDurationComp{
        color: $brandBlue;
        font-size: 1.3rem;
        text-align: left;

        @include  mobile{
            text-align: center;

        }
        .txt{}

        .duration{
            font-weight: bold;
        }

      //////////////////////////////////////
      // DARK UI ///////////////////////////
      &.darkMode {
        color: $darkLightBlue;

      }

    }
</style>
